var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "压缩列表-ziplist-介绍"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#压缩列表-ziplist-介绍"
    }
  }, [_vm._v("#")]), _vm._v(" 压缩列表 (ziplist) 介绍")]), _vm._v(" "), _c('p', [_vm._v("redis 为了节约内存，设计了压缩列表的数据结构，由一系列特殊编码的内存块构成的列表， 一个 ziplist 可以包含多个节点（entry）， 每个节点可以保存一个长度受限的字符数组。每个元素都保存的数据长度信息，这样就可以按长度读取数据，而不需要提前分配好固定大小的数据。")]), _vm._v(" "), _c('p', [_vm._v("可以与数组对比，数组中的每个元素大小都是相同的，实际使用中，我们存的数据有大有小。")]), _vm._v(" "), _c('p', [_vm._v("ziplist 节点构成")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("area        |<------------------- entry -------------------->|\n\n            +------------------+----------+--------+---------+\ncomponent   | pre_entry_length | encoding | length | content |\n            +------------------+----------+--------+---------+\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br')])]), _c('ul', [_c('li', [_vm._v("pre_entry_length 记录了前一个节点的长度，通过这个值，可以进行指针计算，从而跳转到上一个节点")]), _vm._v(" "), _c('li', [_vm._v("encoding 和 length 两部分一起决定了 content 部分所保存的数据的类型（以及长度）")]), _vm._v(" "), _c('li', [_vm._v("content 部分保存着节点的内容，类型和长度由 encoding 和 length 决定。")])]), _vm._v(" "), _c('p', [_vm._v("ziplist 的完整实现要复杂许多，更多信息可以查看："), _c('a', {
    attrs: {
      "href": "https://redisbook.readthedocs.io/en/latest/compress-datastruct/ziplist.html#ziplist",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://redisbook.readthedocs.io/en/latest/compress-datastruct/ziplist.html#ziplist"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "字符串-string"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#字符串-string"
    }
  }, [_vm._v("#")]), _vm._v(" 字符串 - string")]), _vm._v(" "), _c('p', [_vm._v("在 Redis 中， 只有能表示为 long 类型的值， 才会以整数（long）的形式保存， 其他类型的整数、小数和字符串， 都是用简单动态字符串（sdshdr） 结构来保存\ns\n"), _c('img', {
    attrs: {
      "src": require("./01_string.png"),
      "alt": ""
    }
  }), _vm._v("\n(图片来源网络)")]), _vm._v(" "), _c('p', [_vm._v("sbs 源码 "), _c('a', {
    attrs: {
      "href": "https://github.com/redis/redis/blob/25e6d4d4597d6ca06503d5fa76af0e4e1b57302e/src/sds.h",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://github.com/redis/redis/blob/25e6d4d4597d6ca06503d5fa76af0e4e1b57302e/src/sds.h"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "language-c line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-c"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("struct")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("__attribute__")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _vm._v("__packed__"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token class-name"
    }
  }, [_vm._v("sdshdr8")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("{")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token class-name"
    }
  }, [_vm._v("uint8_t")]), _vm._v(" len"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("/* used 已使用长度 */")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token class-name"
    }
  }, [_vm._v("uint8_t")]), _vm._v(" alloc"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("/* excluding the header and null terminator 实际分配的长度，一般大于 len */")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("unsigned")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("char")]), _vm._v(" flags"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("/* 3 lsb of type, 5 unused bits 头部类型 */")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("char")]), _vm._v(" buf"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("[")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("]")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("/* 实际保存的数据 */")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("}")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "列表-list"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#列表-list"
    }
  }, [_vm._v("#")]), _vm._v(" 列表 - list")]), _vm._v(" "), _c('p', [_vm._v("有 2 中实现")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("双向链表")]), _vm._v(" "), _c('li', [_vm._v("压缩列表：需要同时满足以下两个条件\n"), _c('ul', [_c('li', [_vm._v("列表中保存的单个数据小于 64 字节")]), _vm._v(" "), _c('li', [_vm._v("列表中数据个数少于 512 个")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "字典-hash"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#字典-hash"
    }
  }, [_vm._v("#")]), _vm._v(" 字典 - hash")]), _vm._v(" "), _c('p', [_vm._v("有 2 中实现")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("散列表（"), _c('a', {
    attrs: {
      "href": "https://zh.wikipedia.org/wiki/Murmur%E5%93%88%E5%B8%8C",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("MurmurHash2"), _c('OutboundLink')], 1), _vm._v("）\n"), _c('ul', [_c('li', [_vm._v("使用 链表解决哈希冲突问题")]), _vm._v(" "), _c('li', [_vm._v("随着元素个数增、减会动态扩容、缩容")])])]), _vm._v(" "), _c('li', [_vm._v("压缩列表：需要同时满足以下两个条件\n"), _c('ul', [_c('li', [_vm._v("字典中保存的键和值的大小都要小于 64 字节")]), _vm._v(" "), _c('li', [_vm._v("字典中键值对的个数要小于 512 个")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "集合-set"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#集合-set"
    }
  }, [_vm._v("#")]), _vm._v(" 集合 - set")]), _vm._v(" "), _c('p', [_vm._v("有 2 中实现")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("整数数组")]), _vm._v(" "), _c('li', [_vm._v("散列表：需要同时满足以下两个条件\n"), _c('ul', [_c('li', [_vm._v("存储的数据都是整数")]), _vm._v(" "), _c('li', [_vm._v("存储的数据元素个数不超过 512 个")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "有序集合-sortedset"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#有序集合-sortedset"
    }
  }, [_vm._v("#")]), _vm._v(" 有序集合 - sortedset")]), _vm._v(" "), _c('p', [_vm._v("有 2 中实现")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://zh.wikipedia.org/wiki/%E8%B7%B3%E8%B7%83%E5%88%97%E8%A1%A8",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("跳表"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_vm._v("压缩列表：需要同时满足以下两个条件\n"), _c('ul', [_c('li', [_vm._v("所有数据的大小都要小于 64 字节")]), _vm._v(" "), _c('li', [_vm._v("元素个数要小于 128 个")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "汇总"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#汇总"
    }
  }, [_vm._v("#")]), _vm._v(" 汇总")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./01_redis-structure.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("数据结构")]), _vm._v(" "), _c('th', [_vm._v("查询时间复杂度")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("哈希表")]), _vm._v(" "), _c('td', [_vm._v("O(1)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("跳表")]), _vm._v(" "), _c('td', [_vm._v("O(log N)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("双向链表")]), _vm._v(" "), _c('td', [_vm._v("O(N)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("压缩列表")]), _vm._v(" "), _c('td', [_vm._v("O(N)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("整数数组")]), _vm._v(" "), _c('td', [_vm._v("O(N)")])])])]), _vm._v(" "), _c('p', [_vm._v("另外，即使是同一种数据类型的，不同操作的时间复杂度也会不同，具体可以查看 redis 官方文档。")]), _vm._v(" "), _c('p', [_vm._v("以 HMGET 为例：时间复杂度是 O(N)")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./redis-cmd-hash-demo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://redis.io/commands/hmget/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://redis.io/commands/hmget/"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#参考"
    }
  }, [_vm._v("#")]), _vm._v(" 参考")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://redisbook.readthedocs.io/en/latest/index.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Redis 设计与实现"), _c('OutboundLink')], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };